/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Feature_Team_UsersInputs */



/**
* | output |
* | --- |
* | "Unlimited users (min. 5 billed)" |
*
* @param {Plan_Feature_Team_UsersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_feature_team_users = /** @type {((inputs?: Plan_Feature_Team_UsersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Feature_Team_UsersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbegrenzte Nutzer (mind. 5 abgerechnet)")
	return /** @type {LocalizedString} */ ("Unlimited users (min. 5 billed)")
});